@let r = route();
<a class="rc" [routerLink]="['/', r.slug]">
  <span class="rc__codes" aria-hidden="true">
    <span class="rc__iata">{{ r.from.iata }}</span>
    <span class="rc__path"><app-icon name="plane" class="rc__plane" /></span>
    <span class="rc__iata">{{ r.to.iata }}</span>
  </span>
  <span class="rc__title">{{ r.from.city }} to {{ r.to.city }} flights</span>
  <span class="rc__meta">
    <span class="rc__pill"><app-icon name="clock" />{{ r.flightTime }}</span>
    <span class="rc__dist">{{ r.distanceKm | number }} km</span>
  </span>
  <span class="rc__go" aria-hidden="true"><app-icon name="arrow" /></span>
</a>
